let Settings = {};

export function SetSettings(json) {
    Settings = json;
}

export { Settings as default };
